import Backend from 'i18next-chained-backend'
import Cache from './i18n-cache'
import LocizeBackend from 'i18next-locize-backend'
import LocizeEditor from 'locize-editor'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(Backend)
    .use(LocizeEditor)
    .use(initReactI18next)
    .init({
        lng: process.env.I18N_LOCALE,
        fallbackLng: 'nb-NO', // Master
        appendNamespaceToCIMode: true,

        // Note: if omitting saveMissingTo, missing will save to fallbackLng
        saveMissing: process.env.ENVIRONMENT !== 'production',
        saveMissingTo: 'all',

        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',

        debug: process.env.ENVIRONMENT !== 'production',

        keySeparator: '### not used ###', // we use content as keys
        // keySeparator: '-',

        backend: {
            backends: [Cache, LocizeBackend],
            backendOptions: [
                {
                    // prefix for stored languages
                    prefix: 'translations_',
                    // language versions
                    versions: {},
                },
                {
                    projectId: process.env.I18N_LOCIZE_PROJECT_ID,
                    apiKey: process.env.I18N_LOCIZE_API_KEY,
                    referenceLng: process.env.I18N_LOCALE,
                },
            ],
        },

        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ',',
            format: function (value, format) {
                if (format === 'uppercase') return value.toUpperCase()
                if (format === 'bold') return '<strong>' + value + '</strong>'
                return value
            },
        },

        react: {
            useSuspense: true,
        },
    })

export default i18n
